export function camelCaseObject(o) {
  if (o instanceof Array) {
    return o.map((value) => {
      if (typeof value === 'object') {
        value = camelCaseObject(value);
      }
      return value;
    });
  }
  const newO = {};

  if (o) {
    Object.keys(o).forEach((origKey) => {
      const newKey = (origKey.charAt(0).toLowerCase() + origKey.slice(1) || origKey).toString();
      let value = o[origKey];
      if (value instanceof Array || (value !== null && value.constructor === Object)) {
        value = camelCaseObject(value);
      }
      newO[newKey] = value;
    });
  }

  return newO;
}

export const onlyTheseKeys = (object, keys) =>
  Object.keys(object).reduce(
    (removedKeysObject, key) => {
      if (keys.indexOf(key) === -1) {
        delete removedKeysObject[key];
      }

      return removedKeysObject;
    },
    { ...object }
  ) || {};

export const removeTheseKeys = (object, keys) =>
  Object.keys(object).reduce(
    (removedKeysObject, key) => {
      if (keys.indexOf(key) > -1) {
        delete removedKeysObject[key];
      }

      return removedKeysObject;
    },
    { ...object }
  ) || {};

export const removeNulls = (object) =>
  Object.keys(object).reduce(
    (noNullsObject, key) => {
      if (noNullsObject[key] === null) {
        delete noNullsObject[key];
      }

      return noNullsObject;
    },
    { ...object }
  ) || {};

export const removeFalsy = (params) =>
  Object.keys(params).reduce((removedFalsies, paramKey) => {
    if (params[paramKey]) {
      removedFalsies[paramKey] = params[paramKey];
    }

    return removedFalsies;
  }, {}) || {};

export default null;
